import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route } from '@angular/router';
import { HomeComponent } from './home.component';
import { ReferenceSearchComponent } from './inventory/reference/search/reference-search.component';
import { ReceptionSearchComponent } from './inventory/reception/search/reception-search.component';
import { SupplierDetailsComponent } from './inventory/supplier/details/supplier-details.component';
import { SupplierSearchComponent } from './inventory/supplier/search/supplier-search.component';
import { InvoiceDetailsComponent } from './purchase/invoice/details/invoice-details.component';
import { InvoiceNeedaComponent } from './purchase/invoice/needa/invoice-needa.component';
import { InvoiceSearchComponent } from './purchase/invoice/search/invoice-search.component';
import { PurchaseOrderDetailsComponent } from './purchase/order/details/purchase-order-details.component';
import { PurchaseOrderNeedaComponent } from './purchase/order/needa/purchase-order-needa.component';
import { PurchaseOrderSearchComponent } from './purchase/order/search/purchase-order-search.component';
import { RestockDetailComponent } from './purchase/restock/details/restock-details.component';
import { RestockSearchComponent } from './purchase/restock/search/restock-search.component';
import { ReceptionDetailsComponent } from './inventory/reception/details/reception-details.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { LogoutSuccessComponent } from './login/logout-success.component';
import { ReferencenDetailsComponent } from './inventory/reference/details/reference-details.component';
import { RmaSearchComponent } from './inventory/rma/search/rma-search.component';
import { RmaDetailsComponent } from './inventory/rma/details/rma-details.component';
import { SystemOverviewComponent } from './system/system-overview.component';
import { OAuth2CallbackComponent } from './quickbook/oauth2-callback/oauth2-callback.component';
import { GiftCardAlertComponent } from './gift-card-alert/gift-card-alerts/gift-card-alerts.component';
import { PriceChangesComponent } from './inventory/price-change/price-changes/price-changes.component';

function securedRoute(path: string, component: any): Route {
  return { canActivate: [OktaAuthGuard], path: path, component: component };
}

const routes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  { path: 'login/logout-success', component: LogoutSuccessComponent },
  { path: 'quickbook/callback', component: OAuth2CallbackComponent },
  { path: '', redirectTo: '/system', pathMatch: 'full' },
  securedRoute('system', SystemOverviewComponent),
  securedRoute('inventory/reference', ReferenceSearchComponent),
  securedRoute('inventory/price-change', PriceChangesComponent),
  securedRoute('inventory/reference/:isbn', ReferencenDetailsComponent),
  securedRoute('inventory/reception', ReceptionSearchComponent),
  securedRoute('inventory/reception/:reception', ReceptionDetailsComponent),
  securedRoute('inventory/rma', RmaSearchComponent),
  securedRoute('inventory/rma/:rma', RmaDetailsComponent),
  securedRoute('inventory/supplier', SupplierSearchComponent),
  securedRoute('inventory/supplier/:supplier', SupplierDetailsComponent),
  securedRoute('purchase/invoice', InvoiceSearchComponent),
  securedRoute('purchase/invoice/:invoice', InvoiceDetailsComponent),
  securedRoute('purchase/invoice/:invoice/needa/:needaFileName', InvoiceNeedaComponent),
  securedRoute('purchase/restock/:restock', RestockDetailComponent),
  securedRoute('purchase/restock', RestockSearchComponent),
  securedRoute('purchase/order', PurchaseOrderSearchComponent),
  securedRoute('purchase/order/:purchaseOrder', PurchaseOrderDetailsComponent),
  securedRoute('purchase/order/:purchaseOrder/needa/:type', PurchaseOrderNeedaComponent),
  securedRoute('sales/gift-card-alerts', GiftCardAlertComponent),
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
